import { Button, Card, Form, Input, notification } from "antd";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import logo from "../../Assets/Logo.png";
import "./Authenticate.css";
import { AuthenticationService } from "../../Services/AuthenticationService";
import { store } from "../../Redux/store";
import { setToken } from "../../Redux/Slices/userSlice";
import RouteLinks from "../../Router/RouteLinks";


interface LocationProps {
  from: string;
}

const Authentication = () => {

  let location = useLocation();
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
  }, []);

  const OnFinishAuthenticationWithPassword = (values: any) => {
    setIsLoading(true);
    AuthenticationService
      .login(values.username, values.password)
      .then((response) => {
        if (response.status === "loaded") {
          store.dispatch(setToken({
            token: response.payload.token,
            resourceNo: response.payload.resourceNo,
            resourceName: response.payload.resourceName,
            tokenExpiration: "",
          }))

          let state = location.state as LocationProps;
          console.log("state:", state)
          if (
            state &&
            state.from &&
            state.from != ""
          ) {
            navigate(state.from)
          } else
            navigate(`/${RouteLinks.service}/${RouteLinks.planning}`);

        }
      })
      .catch((reason) => {
        console.log(reason);
        notification.error({
          message: "Login mislukt.",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  return (
    <div style={{ display: "flex", height: "100%", backgroundColor: "#1C253B" }}>
      <Card style={{ flex: 1, height: "100%", backgroundColor: "#1C253B", border: "none" }} bodyStyle={{ padding: "20%", height: "100%", display: "grid" }}>
        <Form onFinish={(values: any) => OnFinishAuthenticationWithPassword(values)}>
          <Form.Item style={{ textAlign: "center" }}>
            <img className="logo" alt="Logo" src={logo} style={{ maxHeight: "300px" }} />
          </Form.Item>
          <Form.Item name="username" rules={[{ required: true, message: "Gebruikersnaam is verplicht." }]}>
            <Input
              size="large"
              prefix={<UserOutlined />}
              placeholder={"Gebruikersnaam"}
            />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true }]}>
            <Input
              size="large"
              prefix={<LockOutlined />}
              placeholder={"Wachtwoord"}
              type="password"
            />
          </Form.Item>
          <Form.Item>
            <Button
              loading={isLoading}
              size="large"
              type="primary"
              className="login-form-button"
              htmlType="submit"
              style={{ backgroundColor: "#479BFF" }}
            >
              {"Log in"}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Authentication;
